import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: [ './spinner.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnChanges, OnInit, AfterViewInit {

  @Input() protected visible: boolean = false;
  @Input() promise: Subscription;
  @Input() alwaysVisible: boolean;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    if (this.alwaysVisible) {
      this.visible = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alwaysVisible && changes.alwaysVisible.currentValue) {
      this.visible = true;
    }
    if (!this.visible) {
      if (changes.promise && changes.promise.currentValue) {
        this.visible = true;
        const parentNode = this.elementRef.nativeElement.parentNode;
        parentNode.setAttribute('disabled', true);
        parentNode.classList.add('disabled');
        this.promise.add(() => {
          this.visible = false;
          parentNode.removeAttribute('disabled');
          parentNode.classList.remove('disabled');
        });
      }
    }
  }
}
